import
  React
from 'react';

import {
  Image,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../../constants';

export const TwitterHeader = props => {

  return (

    <>
      <Image
      src={Icons.Twitter}
      width='24px'
      height='20px'/>

      <VContainer
        padding='0 0 0 16px'>

        <Text
          color={CustomColors.Grey8}
          fontWeight='bold'
          fontSize='16px'>

          {props.title}
        </Text>

        <Text
          color={CustomColors.Red1}
          fontSize='14px'>

          {`${props.subtitle} Tweets`}
        </Text>
      </VContainer>
    </>
  );
};